import { VOMedia, VOMediaType } from "../model/DataStructure.js";
import { Icon } from "./Icon.js";
import { MediaContent, MediaContentOptions } from "./MediaContent.js";

export interface MediaIFrameOptions extends MediaContentOptions {

}

export class MediaIFrame extends MediaContent<MediaIFrameOptions>{

    public readonly type: VOMediaType = "iframe";

    private _content: HTMLIFrameElement;
    private _loader: HTMLDivElement;

    constructor(options: MediaIFrameOptions) {
        super(options);

        this._element.classList.add("media-iframe");

        this._loader = document.createElement("div");
        this._loader.className = "media-iframe__loader " + Icon.MEDIA_TYPE_IFRAME;
        this._body.appendChild(this._loader);

        this._content = document.createElement("iframe");
        this._content.className = "media-content__content media-iframe__content media-iframe__content--hidden";
        this._body.appendChild(this._content);

        this._content.addEventListener("load", () => {
            this._content.classList.remove("media-iframe__content--hidden");
            this._loader.classList.add("media-iframe__loader--hidden");
        });

        this.onHide.add(() => {
            this._content.classList.add("media-iframe__content--hidden");
        });
    }

    public load(data: VOMedia): void {
        this.onLoad.dispatch();
        this.onReady.dispatch();
        
        this._content.src = "about:blank";
        this._loader.classList.remove("media-iframe__loader--hidden");
        this._content.src = data.iframe_src;

        this.caption = data.caption || "";
    }
}